/*
  سدر الخليج: التاريخ الهجري بتقويم أم القرى (BLG-23)، في رأس المقال وفي بطاقات المقالات (صفحة المدونة و«اقرأ أيضًا»).
  لكل time[data-sedr-hijri] (من snippets/sedr-article-date) يُضاف قبل الميلادي اليوم والشهر والسنة بالهجري،
  من datetime نفسه فلا يتأثر بتوقيت القارئ. وإن لم يدعم المتصفح التقويم بقي الميلادي وحده.
  وفي الإنجليزية (data-sedr-hijri="en") أسماء الشهور من القائمة هنا، لأن أسماء المتصفحات تختلف («Rabiʻ II» وغيرها).
*/
(function () {
  function hijriDates() {
    var dates = document.querySelectorAll('time[data-sedr-hijri]');
    if (!dates.length) return;
    var fmt, fmtEn;
    try {
      fmt = new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura-nu-latn', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
      fmtEn = new Intl.DateTimeFormat('en-u-ca-islamic-umalqura-nu-latn', { day: 'numeric', month: 'numeric', year: 'numeric', timeZone: 'UTC' });
    } catch (e) { return; }
    if (fmt.resolvedOptions().calendar !== 'islamic-umalqura' || !fmt.formatToParts) return;
    var monthsEn = ['Muharram', 'Safar', 'Rabi’ al-Awwal', 'Rabi’ al-Akhir', 'Jumada al-Ula', 'Jumada al-Akhirah',
      'Rajab', 'Sha’ban', 'Ramadan', 'Shawwal', 'Dhu al-Qa’dah', 'Dhu al-Hijjah'];
    dates.forEach(function (el) {
      var en = el.getAttribute('data-sedr-hijri') === 'en';
      if (en && fmtEn.resolvedOptions().calendar !== 'islamic-umalqura') return;
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('datetime') || '');
      var greg = el.querySelector('.sedr-date__greg');
      if (!m || !greg || el.querySelector('.sedr-date__hijri')) return;
      var parts = {};
      (en ? fmtEn : fmt).formatToParts(new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12))).forEach(function (p) { parts[p.type] = p.value; });
      if (!(+parts.year > 1300 && +parts.year < 1600) || !parts.month || !parts.day) return;
      if (en && !monthsEn[+parts.month - 1]) return;
      var span = document.createElement('span');
      span.className = 'sedr-date__hijri';
      span.textContent = en
        ? parts.day + ' ' + monthsEn[+parts.month - 1] + ' ' + parts.year + ' AH,'
        : parts.day + ' ' + parts.month + ' ' + parts.year + 'هـ،';
      var lead = el.querySelector('.sedr-date__lead');
      if (lead) lead.appendChild(span); else el.insertBefore(span, greg);
      // المسافة خارج الجزأين ليستطيع الميلادي أن ينزل إلى سطر ثانٍ في الشاشة الضيقة.
      el.insertBefore(document.createTextNode(' '), greg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hijriDates);
  } else {
    hijriDates();
  }
})();
